import axios from 'axios';
import apiConfig from '../api.config';

export default function createPremiumSuscription({
  hotelId,
  type,
  clientId,
  customIdentifier,
  pmsId,
}) {
  const {
    host,
    URIs: { createPremiumSuscription: createSalesChannelSuscription },
  } = apiConfig;

  const uri = `${host}${createSalesChannelSuscription}`;

  return axios
    .post(uri, JSON.stringify({ hotelId, type, clientId, customIdentifier, pmsId }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
